import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '../../styles'
import { ButtonBase, ClickAwayListener } from '@material-ui/core'
import Icon from '../../components/icon/Icon'
import makeStyles from '@material-ui/core/styles/makeStyles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import YFManagerDetails from './YFManagerDetails'
import iconsEnum from '../../enums/iconsEnum'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { displayModal, hideModal } from '../reducers/modal/actions'
import { YfManagerModel } from '../../types/yfPopin/yfManagerModel'
import { modalTypes } from '../../enums/modalTypeEnum'
import { isModalVisible } from '../reducers/modal/selector'
import { typeYfDisplay } from '../../enums/yfManagerEnums'
import YFDisplay from './YFDisplay'
import { useIntl } from 'react-intl'
import { WHITE } from '../../theme'

const GREY_BUTTON: string = 'greyButton'
const GREEN_BUTTON: string = 'greenButton'
const ICON_PLUS: string = iconsEnum.Plus

const Accordion = withStyles({
    root: {
        boxShadow: '0px -16px 32px 8px rgba(0, 0, 0, 0.2)',
        transition: 'width 300ms',
        backgroundColor: WHITE,
        width: 430,
        '&:hover': {
            width: 450
        },
        '&$expanded': {
            width: 530,
            margin: 0
        }
    },
    rounded: {
        '&:last-child': {
            borderBottomLeftRadius: 40,
            borderBottomRightRadius: 40
        },
        '&:first-child': {
            borderTopLeftRadius: 40,
            borderTopRightRadius: 40
        }
    },
    expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.blue.main,
        padding: 0,
        borderRadius: 40,
        transitionDuration: '300ms',
        color: WHITE
    },
    content: {
        transform: 'rotate(180deg)',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 8,
        '& svg': {
            fill: WHITE
        },

        '& #greenButton': {
            transitionDuration: '300ms',
            backgroundColor: theme.palette.dynamicGreenToWhite.main,
            '& svg': {
                fill: theme.palette.textAccessibility.main
            },

        },
        '& #greyButton': {
            transitionDuration: '300ms',
            backgroundColor: theme.palette.blue['5'],
            '& svg': {
                fill: theme.palette.blue.main
            },
            transform: 'rotate(-45deg)'
        },
        '&$expanded': {
            margin: 8
        }

    },
    expanded: {}
}))(MuiAccordionSummary)

const AccordionDetails = withStyles({
    root: {
        transform: 'rotate(180deg)',
        padding: 0
    }
})(MuiAccordionDetails)

const useStyle = makeStyles((theme) => ({
        ...styles(theme),
        buttonLargeScreen: {
            width: 40,
            height: 40,
            borderRadius: 40,
            zIndex: 1121
        },
        yfLabel: {
            display: 'flex',
            alignItems: 'center',
            transitionDuration: '300ms'
        },
        yfContainer: {
            transform: 'rotate(180deg)',
            position: 'fixed',
            zIndex: 1120,
            bottom: 24,
            right: 40
        },
        yfTitleDiv: {
            flexDirection: 'column',
            marginLeft: '6%',
            whiteSpace: 'nowrap'
        },
        yfSubTitleDiv: {
            marginTop: 2,
            whiteSpace: 'nowrap'
        },
        icon: {
            fill: WHITE
        }
    }
))

interface AcceptingProps {
    subTitle: string,
    managerTitle: string,
    urgenceLabel: string,
    youfirstManager: YfManagerModel,
}

type YFManagerPopInProps = AcceptingProps

const YFManagerPopIn: React.FC<YFManagerPopInProps> = (
    {
        subTitle,
        managerTitle,
        urgenceLabel,
        youfirstManager
    }
) => {
    const classes = useStyle()
    const intl = useIntl()
    const is_open = useSelector((state: RootState) => isModalVisible(state, modalTypes.youFirstManager))
    const dispatch = useDispatch()

    const handleExpand = React.useCallback((event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        if (isExpanded) {
            dispatch(
                displayModal(modalTypes.youFirstManager)
            )
        } else {
            dispatch(
                hideModal(modalTypes.youFirstManager)
            )
        }
    }, [dispatch])


    const closeModal = React.useCallback((event: React.MouseEvent<Document>) => {
        if (is_open) {
            dispatch(
                hideModal(modalTypes.youFirstManager)
            )
        }
    }, [dispatch, is_open])

    return (
        <>
            {
                youfirstManager.popin_thumbnail && youfirstManager.request_thumbnail && youfirstManager.picture &&
                <ClickAwayListener onClickAway={closeModal} mouseEvent={is_open ? 'onClick' : false}>
                    <div className={classes.yfContainer}>
                        <Accordion
                            TransitionProps={{
                                timeout: {
                                    appear: 300,
                                    enter: 300,
                                    exit: 300
                                }
                            }}
                            onChange={handleExpand}
                            expanded={is_open}>
                            <AccordionSummary>
                                <div className={classes.yfLabel}>
                                    <YFDisplay type={typeYfDisplay.POPIN}/>
                                    <div className={classes.yfTitleDiv}>
									<span className={classes.title5}>
		                                {youfirstManager.data.nom}
		                            </span>

                                        {
                                            youfirstManager.data.nom !== intl.formatMessage(
                                                {
                                                    id: 'you_first_manager.defaultYfm',
                                                    defaultMessage: 'Votre équipe YouFirst',
                                                    description: 'YouFirst default name'
                                                }
                                            ) && (
                                                <div className={classes.yfSubTitleDiv}>
												<span className={classes.text3}>
													{subTitle}
												</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <ButtonBase id={is_open ? GREY_BUTTON : GREEN_BUTTON} className={classes.buttonLargeScreen}>
                                    <Icon icon={ICON_PLUS} size={12}/>
                                </ButtonBase>
                            </AccordionSummary>
                            <AccordionDetails>
                                <YFManagerDetails
                                    managerTitle={managerTitle}
                                    urgenceLabel={urgenceLabel}
                                    youfirstManager={youfirstManager}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </ClickAwayListener>
            }
        </>
    )
}

export default YFManagerPopIn
